import { useEffect } from "react";
import styles from './usePixieDust.module.css';
import anime from "animejs";

/** usePixieDust
 * in order to use this, u must declare a class name of pixie-dust in the element you want to apply the pixie dust effect
 * @returns {void}
 *  */
const usePixieDust = () => {

    const animation = (element, event) => {
        // const rect = element.getBoundingClientRect();

        for (let i = 0; i < 1; i++) {
            const particle = document.createElement('div');
            particle.classList.add(styles.particle);

            // const x = rect.left + rect.width / 2;
            // const y = rect.top + rect.height / 2;
            //mouse position
            const x = event.clientX;
            const y = event.clientY;
            const angle = Math.random() * Math.PI * 2;
            const distance = Math.random() * 50 + 30;

            particle.style.left = `${x}px`;
            particle.style.top = `${y}px`;
            particle.style.transform = `translate(-50%, -50%)`;

            document.body.appendChild(particle);

            anime({
                targets: particle,
                translateX: Math.cos(angle) * distance,
                translateY: Math.sin(angle) * distance,
                opacity: [1, 0],
                scale: [1, 0.4],
                easing: 'easeOutQuad',
                duration: 1500,
                complete: () => particle.remove()
            });
        }
    };
    useEffect(() => {
        const pixieDustElements = document.querySelectorAll('.pixie-dust');

        pixieDustElements.forEach(element => {
            element.addEventListener('mousemove', (event) => {
                animation(element, event);
            });
        });

        return () => {
            pixieDustElements.forEach(element => {
                element.removeEventListener('mouseenter', () => {
                    animation(element);
                });
            });
        };
    }, []);

    return styles.pixieDust;
};

export default usePixieDust;